import { useTranslation } from '@mint-lib/i18n';
import { Button } from '@mint-lib/tw-components';
import { useSnapshot } from 'valtio';

import { RichTooltip } from '../../atoms/RichTooltip.jsx';
import type { TemplateDuplicationFormState } from './types.js';

type TemplateDuplicateSubmitButtonProps = {
  state: TemplateDuplicationFormState;
  isSubmitting: boolean;
};

export const TemplateDuplicateSubmitButton = ({
  state,
  isSubmitting,
}: TemplateDuplicateSubmitButtonProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const snap = useSnapshot(state);

  const isDuplicateNameError =
    snap.ui.submissionError === 'DuplicatedTemplateNameError';

  const activeError = isDuplicateNameError
    ? t('Template name must be unique')
    : snap.validationError;

  return (
    <RichTooltip asChild description={activeError} side="left">
      <div className="ml-auto">
        <Button
          type="submit"
          variant="contained"
          disabled={Boolean(activeError) || isSubmitting}
          data-dd-action-name="Duplicate"
        >
          {t('Duplicate')}
        </Button>
      </div>
    </RichTooltip>
  );
};
